import { render, staticRenderFns } from "./ProductListHorizonLoader.vue?vue&type=template&id=1e5c715a&scoped=true&"
var script = {}
import style0 from "./ProductListHorizonLoader.vue?vue&type=style&index=0&id=1e5c715a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5c715a",
  null
  
)

export default component.exports